// extracted by mini-css-extract-plugin
module.exports = {"Page":"PriceType_Page__K3riR"};